import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight, Building2, Globe2, LogOut } from "lucide-react";
import { API } from "@/components/listings/common";

function Card({ icon: Icon, title, url, desc, items, onClick, badge, testid }) {
  return (
    <button className="chooser-card" onClick={onClick} data-testid={testid}>
      <span className="chooser-icon"><Icon size={26} /></span>
      {badge > 0 && <em className="chooser-badge" data-testid={`${testid}-badge`}>{badge} ilan onay bekliyor</em>}
      <h2>{title}</h2>
      <small className="chooser-url">{url}</small>
      <p>{desc}</p>
      <ul>{items.map((x) => <li key={x}>{x}</li>)}</ul>
      <span className="chooser-go">Panele gir <ArrowUpRight size={16} /></span>
    </button>
  );
}

export default function PanelChooser({ brand, user, go, onLogout }) {
  const [pending, setPending] = useState(0);
  useEffect(() => { axios.get(`${API}/platform/summary`).then((r) => setPending(r.data.listings.pending)).catch(() => {}); }, []);
  return (
    <main className="chooser-shell" data-testid="panel-chooser">
      <header className="chooser-top">{brand}<div className="user-mini"><span><b>{user.name}</b><small>Yönetici</small></span><button className="icon-btn" onClick={onLogout} data-testid="chooser-logout"><LogOut size={16} /></button></div></header>
      <section className="chooser-body">
        <span className="eyebrow">PANEL SEÇİMİ</span>
        <h1>Hangi panele girmek istiyorsunuz?</h1>
        <p className="chooser-lead">İstediğiniz zaman sol menüdeki panel kutusundan diğer panele geçebilirsiniz.</p>
        <div className="chooser-grid">
          <Card icon={Building2} title="Emlak Ofisi" url="emlaksepeti.online/admin" desc="Ofisinizin günlük işleri ve finansı." items={["Gelir & gider, raporlar, ödeme takvimi", "Sözleşmeler, ekipler, kira takibi", "Ofis ilanları, WhatsApp ve Instagram"]} onClick={() => go("/admin/genelbakis")} testid="chooser-office" />
          <Card icon={Globe2} title="Emlak Sepeti" url="emlaksepeti.online/admin/kurumsal" desc="İlan sitesinin ve üyelerin yönetimi." items={["Bireysel ve kurumsal üyeler", "Üye ilanlarının onayı ve reddi", "Site ayarları (iletişim, ana sayfa, hakkımızda)"]} onClick={() => go("/admin/kurumsal")} badge={pending} testid="chooser-platform" />
        </div>
      </section>
    </main>
  );
}
